// Extracted from `pages/CustomerDetailPage.js` (P2 refactor step 4e).
// Tab "Servicios Contratados" — 1:1 move del JSX. Muestra la tabla de
// servicios con soporte para grupos multi-extensión (Centralita 3x →
// filas expandibles) y filas de add-ons. Todo el estado y los handlers
// viven en el padre y se inyectan como props para no cambiar la
// funcionalidad ni el estilo.
import React from "react";
import { Card, CardContent } from "../ui/card";
import { Button } from "../ui/button";
import { Badge } from "../ui/badge";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../ui/table";
import {
  Package,
  Eye,
  AlertTriangle,
  FileText,
  Trash2,
  ChevronDown,
  ChevronRight,
} from "lucide-react";
import { formatDateES, serviceStatusColors } from "./utils";

export const ServiciosTab = ({
  services,
  groupedServices,
  renderAddonRow,
  expandedServiceGroups,
  setExpandedServiceGroups,
  setSelectedService,
  setServiceDetailOpen,
  setDeleteConfirm,
  navigate,
  customerId,
  formatCurrency,
}) => {
  return (
    <>
      <div className="flex justify-between items-center">
        <h3 className="text-lg font-heading font-semibold text-white">
          Servicios Contratados
        </h3>
      </div>

      <Card className="bg-[#0A0A35] border-[#1E1E5F]">
        <CardContent className="pt-6">
          {services.length === 0 ? (
            <div className="text-center py-8">
              <Package className="h-12 w-12 text-slate-500 mx-auto mb-4" />
              <p className="text-slate-400">No hay servicios contratados</p>
            </div>
          ) : (
            <div className="overflow-x-auto">
              <Table>
                <TableHeader>
                  <TableRow className="border-[#1E1E5F]">
                    <TableHead className="text-slate-400">Nombre servicio</TableHead>
                    <TableHead className="text-slate-400">Proveedor</TableHead>
                    <TableHead className="text-slate-400">Precio (sin IVA)</TableHead>
                    <TableHead className="text-slate-400">Precio (con IVA)</TableHead>
                    <TableHead className="text-slate-400">Descuento</TableHead>
                    <TableHead className="text-slate-400">Días dto.</TableHead>
                    <TableHead className="text-slate-400">Permanencia</TableHead>
                    <TableHead className="text-slate-400">Estado</TableHead>
                    <TableHead className="text-slate-400">Fecha alta</TableHead>
                    <TableHead className="text-slate-400">Acciones</TableHead>
                  </TableRow>
                </TableHeader>
                <TableBody>
                  {groupedServices.map((entry) => {
                    if (entry.type === "single") {
                      const service = entry.service;
                      const addons = entry.addons || [];
                      return (
                    <React.Fragment key={service.id}>
                    <TableRow
                      className="border-[#1E1E5F] hover:bg-[#1B1B4B]/50 cursor-pointer"
                      onClick={() => {
                        setSelectedService(service);
                        setServiceDetailOpen(true);
                      }}
                    >
                      <TableCell className="text-white font-medium">{service.nombre_servicio}</TableCell>
                      <TableCell className="text-slate-300">{service.proveedor_nombre || service.proveedor || "-"}</TableCell>
                      <TableCell className="text-slate-300">{formatCurrency(service.precio_sin_iva)}</TableCell>
                      <TableCell className="text-[#42E695] font-medium">{formatCurrency(service.precio_final)}</TableCell>
                      <TableCell className="text-slate-300">{formatCurrency(service.descuento_monto)}</TableCell>
                      <TableCell>
                        {service.dias_restantes_descuento !== null && service.dias_restantes_descuento !== undefined ? (
                          <Badge className={service.dias_restantes_descuento > 30 ? "bg-[#42E695]/20 text-[#42E695]" :
                                           service.dias_restantes_descuento > 7 ? "bg-yellow-500/20 text-yellow-400" :
                                           "bg-red-500/20 text-red-400"}>
                            {service.dias_restantes_descuento} días
                          </Badge>
                        ) : (
                          <span className="text-slate-500">-</span>
                        )}
                      </TableCell>
                      <TableCell>
                        {service.dias_restantes_permanencia !== null && service.dias_restantes_permanencia !== undefined ? (
                          <div className="flex flex-col">
                            <Badge className={service.dias_restantes_permanencia > 90 ? "bg-purple-500/20 text-purple-400" :
                                             service.dias_restantes_permanencia > 30 ? "bg-yellow-500/20 text-yellow-400" :
                                             "bg-[#42E695]/20 text-[#42E695]"}>
                              {service.dias_restantes_permanencia} días
                            </Badge>
                            <span className="text-slate-500 text-xs mt-1">Hasta: {formatDateES(service.fecha_fin_permanencia)}</span>
                          </div>
                        ) : (
                          <span className="text-slate-500">-</span>
                        )}
                      </TableCell>
                      <TableCell>
                        <Badge className={serviceStatusColors[service.estado]}>
                          {service.estado}
                        </Badge>
                      </TableCell>
                      <TableCell className="text-slate-300">{formatDateES(service.fecha_alta)}</TableCell>
                      <TableCell>
                        <div className="flex gap-1" onClick={(e) => e.stopPropagation()}>
                          <Button
                            size="sm"
                            variant="ghost"
                            onClick={() => {
                              setSelectedService(service);
                              setServiceDetailOpen(true);
                            }}
                            className="text-[#03BEE4] hover:text-[#03BEE4]/80 h-8 w-8 p-0"
                            title="Ver detalle"
                          >
                            <Eye className="h-4 w-4" />
                          </Button>
                          <Button
                            size="sm"
                            variant="ghost"
                            onClick={() => {
                              navigate(`/incidents?action=create&customer=${customerId}&service=${service.id}`);
                            }}
                            className="text-red-400 hover:text-red-300 h-8 w-8 p-0"
                            title="Crear Incidencia"
                          >
                            <AlertTriangle className="h-4 w-4" />
                          </Button>
                          <Button
                            size="sm"
                            variant="ghost"
                            onClick={() => {
                              navigate(`/requests?action=create&customer=${customerId}&service=${service.id}`);
                            }}
                            className="text-blue-400 hover:text-blue-300 h-8 w-8 p-0"
                            title="Crear Solicitud"
                          >
                            <FileText className="h-4 w-4" />
                          </Button>
                          <Button
                            size="sm"
                            variant="ghost"
                            onClick={(e) => {
                              e.stopPropagation();
                              setDeleteConfirm({ open: true, type: "service", id: service.id, name: service.nombre_servicio });
                            }}
                            className="text-red-400 hover:text-red-300 hover:bg-red-500/10 h-8 w-8 p-0"
                            title="Eliminar"
                            data-testid={`delete-service-${service.id}`}
                          >
                            <Trash2 className="h-4 w-4" />
                          </Button>
                        </div>
                      </TableCell>
                    </TableRow>
                    {addons.map((ad) => renderAddonRow(ad, service.id, 1))}
                    </React.Fragment>
                      );
                    }
                    // entry.type === "group" — aggregated parent row + expandable children
                    const children = entry.children;
                    const first = children[0];
                    const n = children.length;
                    const isOpen = !!expandedServiceGroups[entry.key];
                    const sumAddons = (c, field) =>
                      (c._addons || []).reduce((a, ad) => a + (parseFloat(ad[field]) || 0), 0);
                    const total_sin_iva = children.reduce((s, c) => s + (parseFloat(c.precio_sin_iva) || 0) + sumAddons(c, "precio_sin_iva"), 0);
                    const total_final   = children.reduce((s, c) => s + (parseFloat(c.precio_final)   || 0) + sumAddons(c, "precio_final"),   0);
                    const total_dto     = children.reduce((s, c) => s + (parseFloat(c.descuento_monto)|| 0) + sumAddons(c, "descuento_monto"),0);
                    const toggle = (e) => { e.stopPropagation(); setExpandedServiceGroups(prev => ({ ...prev, [entry.key]: !prev[entry.key] })); };
                    return (
                      <React.Fragment key={entry.key}>
                        <TableRow
                          className="border-[#1E1E5F] hover:bg-[#1B1B4B]/50 cursor-pointer bg-[#0F0F3D]/40"
                          data-testid={`service-group-${entry.key}`}
                          onClick={toggle}
                        >
                          <TableCell className="text-white font-medium">
                            <div className="flex items-center gap-2">
                              <button
                                type="button"
                                onClick={toggle}
                                className="text-slate-400 hover:text-white"
                                data-testid={`service-group-toggle-${entry.key}`}
                              >
                                {isOpen ? <ChevronDown className="h-4 w-4" /> : <ChevronRight className="h-4 w-4" />}
                              </button>
                              <span>{first.nombre_servicio}</span>
                              <Badge className="bg-[#03BEE4]/15 text-[#03BEE4] border border-[#03BEE4]/30 text-[10px]">
                                {n} extensiones
                              </Badge>
                            </div>
                          </TableCell>
                          <TableCell className="text-slate-300">{first.proveedor_nombre || first.proveedor || "-"}</TableCell>
                          <TableCell className="text-slate-300">{formatCurrency(total_sin_iva)}</TableCell>
                          <TableCell className="text-[#42E695] font-medium">{formatCurrency(total_final)}</TableCell>
                          <TableCell className="text-slate-300">{formatCurrency(total_dto)}</TableCell>
                          <TableCell>
                            {first.dias_restantes_descuento != null ? (
                              <Badge className={first.dias_restantes_descuento > 30 ? "bg-[#42E695]/20 text-[#42E695]" :
                                               first.dias_restantes_descuento > 7 ? "bg-yellow-500/20 text-yellow-400" :
                                               "bg-red-500/20 text-red-400"}>
                                {first.dias_restantes_descuento} días
                              </Badge>
                            ) : <span className="text-slate-500">-</span>}
                          </TableCell>
                          <TableCell>
                            {first.dias_restantes_permanencia != null ? (
                              <Badge className={first.dias_restantes_permanencia > 90 ? "bg-purple-500/20 text-purple-400" :
                                               first.dias_restantes_permanencia > 30 ? "bg-yellow-500/20 text-yellow-400" :
                                               "bg-[#42E695]/20 text-[#42E695]"}>
                                {first.dias_restantes_permanencia} días
                              </Badge>
                            ) : <span className="text-slate-500">-</span>}
                          </TableCell>
                          <TableCell>
                            <Badge className={serviceStatusColors[first.estado]}>{first.estado}</Badge>
                          </TableCell>
                          <TableCell className="text-slate-300">{formatDateES(first.fecha_alta)}</TableCell>
                          <TableCell>
                            <div className="flex gap-1" onClick={(e) => e.stopPropagation()}>
                              <Button
                                size="sm"
                                variant="ghost"
                                onClick={() => { setSelectedService(first); setServiceDetailOpen(true); }}
                                className="text-[#03BEE4] hover:text-[#03BEE4]/80 h-8 w-8 p-0"
                                title="Ver detalle"
                                data-testid={`service-group-view-${entry.key}`}
                              >
                                <Eye className="h-4 w-4" />
                              </Button>
                              <Button
                                size="sm"
                                variant="ghost"
                                onClick={() => { navigate(`/incidents?action=create&customer=${customerId}&service=${first.id}`); }}
                                className="text-red-400 hover:text-red-300 h-8 w-8 p-0"
                                title="Crear Incidencia"
                                data-testid={`service-group-incident-${entry.key}`}
                              >
                                <AlertTriangle className="h-4 w-4" />
                              </Button>
                              <Button
                                size="sm"
                                variant="ghost"
                                onClick={() => { navigate(`/requests?action=create&customer=${customerId}&service=${first.id}`); }}
                                className="text-blue-400 hover:text-blue-300 h-8 w-8 p-0"
                                title="Crear Solicitud"
                                data-testid={`service-group-request-${entry.key}`}
                              >
                                <FileText className="h-4 w-4" />
                              </Button>
                              <Button
                                size="sm"
                                variant="ghost"
                                onClick={(e) => { e.stopPropagation(); setDeleteConfirm({ open: true, type: "service", id: first.id, name: first.nombre_servicio }); }}
                                className="text-red-400 hover:text-red-300 hover:bg-red-500/10 h-8 w-8 p-0"
                                title="Eliminar"
                                data-testid={`service-group-delete-${entry.key}`}
                              >
                                <Trash2 className="h-4 w-4" />
                              </Button>
                              <Button
                                size="sm"
                                variant="ghost"
                                onClick={toggle}
                                className="text-[#03BEE4] hover:text-[#03BEE4]/80 h-8 w-8 p-0"
                                title={isOpen ? "Contraer" : "Expandir extensiones"}
                                data-testid={`service-group-toggle-btn-${entry.key}`}
                              >
                                {isOpen ? <ChevronDown className="h-4 w-4" /> : <ChevronRight className="h-4 w-4" />}
                              </Button>
                            </div>
                          </TableCell>
                        </TableRow>
                        {isOpen && children.map((child, idx) => (
                          <React.Fragment key={child.id}>
                          <TableRow
                            className="border-[#1E1E5F] hover:bg-[#1B1B4B]/30 cursor-pointer bg-[#0A0A35]/60"
                            data-testid={`service-group-${entry.key}-child-${idx}`}
                            onClick={() => { setSelectedService(child); setServiceDetailOpen(true); }}
                          >
                            <TableCell className="text-slate-300 pl-10 text-sm">
                              └─ Ext {child.linea_numero ?? (idx + 1)}
                              {entry.legacy && <span className="text-slate-500 text-[10px] ml-2">(histórico)</span>}
                            </TableCell>
                            <TableCell className="text-slate-400 text-sm">{child.proveedor_nombre || child.proveedor || "-"}</TableCell>
                            <TableCell className="text-slate-400 text-sm">{formatCurrency(child.precio_sin_iva)}</TableCell>
                            <TableCell className="text-[#42E695]/80 text-sm">{formatCurrency(child.precio_final)}</TableCell>
                            <TableCell className="text-slate-400 text-sm">{formatCurrency(child.descuento_monto)}</TableCell>
                            <TableCell></TableCell>
                            <TableCell></TableCell>
                            <TableCell><Badge className={serviceStatusColors[child.estado]}>{child.estado}</Badge></TableCell>
                            <TableCell className="text-slate-400 text-sm">{formatDateES(child.fecha_alta)}</TableCell>
                            <TableCell>
                              <div className="flex gap-1" onClick={(e) => e.stopPropagation()}>
                                <Button size="sm" variant="ghost" onClick={() => { setSelectedService(child); setServiceDetailOpen(true); }} className="text-[#03BEE4] hover:text-[#03BEE4]/80 h-8 w-8 p-0" title="Ver detalle">
                                  <Eye className="h-4 w-4" />
                                </Button>
                                <Button size="sm" variant="ghost"
                                  onClick={() => { navigate(`/incidents?action=create&customer=${customerId}&service=${child.id}`); }}
                                  className="text-red-400 hover:text-red-300 h-8 w-8 p-0" title="Crear Incidencia"
                                  data-testid={`child-incident-${child.id}`}>
                                  <AlertTriangle className="h-4 w-4" />
                                </Button>
                                <Button size="sm" variant="ghost"
                                  onClick={() => { navigate(`/requests?action=create&customer=${customerId}&service=${child.id}`); }}
                                  className="text-blue-400 hover:text-blue-300 h-8 w-8 p-0" title="Crear Solicitud"
                                  data-testid={`child-request-${child.id}`}>
                                  <FileText className="h-4 w-4" />
                                </Button>
                                <Button size="sm" variant="ghost" onClick={(e) => { e.stopPropagation(); setDeleteConfirm({ open: true, type: "service", id: child.id, name: child.nombre_servicio }); }} className="text-red-400 hover:text-red-300 hover:bg-red-500/10 h-8 w-8 p-0" title="Eliminar" data-testid={`delete-service-${child.id}`}>
                                  <Trash2 className="h-4 w-4" />
                                </Button>
                              </div>
                            </TableCell>
                          </TableRow>
                          {(child._addons || []).map(ad => renderAddonRow(ad, child.id, 2))}
                          </React.Fragment>
                        ))}
                      </React.Fragment>
                    );
                  })}
                </TableBody>
              </Table>
            </div>
          )}
        </CardContent>
      </Card>
    </>
  );
};
